// 根据key动态获取配置文件信息
export const getConfig = (key) => {
  try {
    return require(`portal-common/config/${key}.js`);
  } catch (err) {
    console.error('getConfig', err);
  }
};
